/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import DuesList from "./DueList";
import { PageWrapper } from "../../../shared/layout";
import {
  Tabs, BarLoader, ExportButton, Button,
} from "../../../shared/widgets";
import { NEW_BASE_URL, MessageType } from "../../../Constant";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import UploadExcelModal from "../../../shared/components/fileupload/UploadExcelModal";
import { getBulkSettlementProcessStatusService } from "../../../services/settlementService";
import "./settlement.css";

import { newReconDownloadExcelAPI } from "../../../services/APIutils";

import { saveExcelBlob } from "../../../shared/methods/sharedMethods";

class SettlementList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "pendingDues",
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      activeStep: 0,
      selected: [],
      searchString: "",
      showUploadXlsxModal: false,
      bulkSettlementProcessState: {
        isProcessing: true,
        message: "",
      },
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.toggleUploadXlsxModal = this.toggleUploadXlsxModal.bind(this, true);
  }

  componentDidMount() {
    this.getBulkSettlementProcessStatus();
  }

  handleTabChange(value) {
    this.setState({ value, page: 0, selected: [] });
  }

  exportSampleSettlementUploadSheet = () => {
    this.newCreateFormAndSubmit({ url: `${NEW_BASE_URL}/v1/settlementsPage/exportSampleSettlementUploadSheet` });
  };

  getBulkSettlementProcessStatus = () => {
    // Api call to get settlement process status
    getBulkSettlementProcessStatusService()
      .then((res) => {
        this.setState({
          bulkSettlementProcessState: res,
        });
      });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  exportPendingDues = async () => {
    const { cityFilter, operatorFilter } = this.props;
    const query = {
      platform: "web",
      timezoneOffset: -330,
      addOnFilter: {
        cityIdArr: cityFilter || [],
        operatorIdArr: operatorFilter || [],
        isSettledEntries: true,
      },
    };
    this.newCreateFormAndSubmit({
      uriProps: query,
      url: `${NEW_BASE_URL}/v1/settlementsPage/exportPendingDues`,
    });
  };

  newCreateFormAndSubmit = ({ uriProps = {}, url }) => {
    newReconDownloadExcelAPI(url, uriProps).then((res) => {
      let fileName = res.headers["content-disposition"].split("Filename=")[1];
      fileName = fileName.replaceAll("\"", "");
      saveExcelBlob({ blob: res.data, fileName });
    });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  handleSearchChange = (e) => {
    this.setState({
      searchString: e,
    });
  };

  toggleUploadXlsxModal(data) {
    this.setState({
      showUploadXlsxModal: data,
    });
  }

  displayUploadXlsxModalModal() {
    const { showUploadXlsxModal, bulkSettlementProcessState } = this.state;
    return (
      <UploadExcelModal
        showModal={showUploadXlsxModal}
        messageCallBack={(type) => {
          if (type === MessageType.SUCCESS) {
            this.getBulkSettlementProcessStatus();
          }
          if (type === MessageType.SUCCESS || !(type && type === MessageType.ERROR)) {
            this.setState({
              showUploadXlsxModal: false,
            });
          }
        }}
        isUploadDisabled={bulkSettlementProcessState.isProcessing}
        uploadType="settlement"
      />
    );
  }

  render() {
    const { cityFilter, operatorFilter, refreshUpliftStatus } = this.props;
    const { bulkSettlementProcessState, value, showUploadXlsxModal } = this.state;

    const endpoint = "settlementsPage/exportPendingDues";
    const exportSettlementquery = {
      platform: "web",
      timezoneOffset: -330,
      addOnFilter: {
        cityIdArr: cityFilter || [],
        operatorIdArr: operatorFilter || [],
        isSettledEntries: true,
      },
    };

    return (
      <div className="pageContainer settlement-wrap">
        <PageWrapper>
          <PageWrapper.Header heading="Settlements" hideS>
            <div className="dataTables_length tabWrapper scroll-tab">
              <Tabs
                activeTab={value}
                tabs={[
                  {
                    key: "pendingDues",
                    display: "Due Amount",
                  },
                  // {
                  //   key: "settledDues",
                  //   display: "Settled Amount"
                  // }
                ]}
                onTabSelection={(key) => {
                  this.handleTabChange(key);
                }}
              />
            </div>
            <div className="pull-right">
              <div className="progress-heading">
                <span>{refreshUpliftStatus || ""}</span>
              </div>
            </div>
            {value === "pendingDues" && (
              <div className="pull-right">
                {bulkSettlementProcessState.isProcessing && (
                  <span className="in-process-text">
                    {bulkSettlementProcessState.message}
                  </span>
                )}
                <a
                  role="link"
                  className="sample-button"
                  onClick={this.exportSampleSettlementUploadSheet}
                  onKeyDown={() => { /* onKeyDown */ }}
                  tabIndex="0"
                >
                  Sample File
                </a>
                <Button
                  disable={bulkSettlementProcessState.isProcessing}
                  onClick={this.toggleUploadXlsxModal}
                  buttonText="Upload"
                />
                <ExportButton
                  query={exportSettlementquery}
                  endpoint={endpoint}
                  pageName="Settlement"
                  isDisable={
                    refreshUpliftStatus === "Data Sync In Process"
                  }
                />
              </div>
            )}
          </PageWrapper.Header>
          <PageWrapper.Body customClass="settlement-body">
            <BarLoader scope="header" />
            {value === "pendingDues" ? (
              <DuesList type="pending" />
            ) : (
              <DuesList />
            )}
            {showUploadXlsxModal
              && this.displayUploadXlsxModalModal()}
          </PageWrapper.Body>
        </PageWrapper>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    content:
     state?.Contracts?.nonContractList?.items || [],
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
  };
}
const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SettlementList);
